import { useCollapse } from '@uhg-abyss/web/hooks/useCollapse';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Button } from '@uhg-abyss/web/ui/Button';
import { CollapseProvider } from '@uhg-abyss/web/ui/CollapseProvider';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Link } from '@uhg-abyss/web/ui/Link';
import { Text } from '@uhg-abyss/web/ui/Text';
import isEmpty from 'lodash/isEmpty';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CUSTOMN_MESSAGE_TRUNCATE_CHARACTERS } from '../../Constants';

const ReadMoreOrLessButton = styled(Button, {
  '&.abyss-button-root': {
    paddingLeft: '0px',
  },
});
export const CtaTextLink = styled(Link, {
  '&.abyss-link-root': {
    borderColor: '$core.color.brand.60',
    backgroundColor: '#FFFFFF',
    border: '1px solid $core.color.brand.60',
    borderRadius: '4px',
    padding: '8px',
    marginTop: '4px',
  },
});

export const LAWWCtaTextLink = styled(Link, {
  '&.abyss-link-root': {
    color: '$uhcPrimary1',
  },
});

type ExpandCollapseProps = {
  text: string;
  linkText?: string | null;
  linkUrl?: string | null;
  truncateLength?: number;
};

export const ExpandCollapse = ({
  text,
  linkText,
  linkUrl,
  truncateLength = 100,
}: ExpandCollapseProps) => {
  const { t } = useTranslation();

  const { collapseProps, buttonProps, isOpen } = useCollapse({
    defaultIsOpen: false,
    duration: 1000,
  });
  const isTextLengthy = text?.length >= truncateLength;
  return (
    <CollapseProvider defaultIsOpen={false}>
      <React.Fragment>
        <Flex {...collapseProps}>
          {isOpen ? (
            <Layout.Stack alignItems="left">
              <Text
                color="$core.color.neutral.90"
                data-auto-testid="custom-message-text-full"
                data-testid="custom-message-text-full"
              >
                {text}
              </Text>
              {linkText && !isEmpty(linkText) && (
                <CtaTextLink
                  data-auto-testid="custom-message-link"
                  data-testid="custom-message-link"
                  href={linkUrl}
                >
                  {linkText}
                </CtaTextLink>
              )}
            </Layout.Stack>
          ) : (
            <Text
              color="$core.color.neutral.90"
              data-auto-testid="custom-message-text-ellipsis"
              data-testid="custom-message-text-ellipsis"
            >
              {isTextLengthy
                ? `${text.substring(
                    0,
                    CUSTOMN_MESSAGE_TRUNCATE_CHARACTERS
                  )} ...`
                : text}
            </Text>
          )}
          {isTextLengthy && (
            <ReadMoreOrLessButton
              icon={{
                icon: isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down',
                position: 'trailing',
              }}
              variant="text"
              {...buttonProps}
            >
              {isOpen ? t('READ_LESS') : t('READ_MORE')}
            </ReadMoreOrLessButton>
          )}
        </Flex>
      </React.Fragment>
    </CollapseProvider>
  );
};
